export const CLIENT_ATTACHMENTS_VALIDATION_RULES = {
  clientAttachmentUploader: {
    isRequiredFile: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/clientAttachments/clientAttachmentsValidationRules.js